// extracted by mini-css-extract-plugin
module.exports = {"root":"SortAdornment_root__3q3We","icon":"SortAdornment_icon__2kKjP","up":"SortAdornment_up__1F2y_","down":"SortAdornment_down__24srk","active":"SortAdornment_active__2Hfax"};